import store from '../store/store';
import { getUserConfiguration } from 'owa-session-store';
import { select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
    userOptions: function () { return getUserConfiguration().UserOptions; },
})(function IsInlinePreviewsDirty(state) {
    return (state.optionState.isEnabled !== null &&
        state.optionState.isEnabled !== state.userOptions.ShowInlinePreviews);
});
//# sourceMappingURL=isInlinePreviewsOptionDirty.js.map